// @flow
import React from 'react';
import { Helmet } from 'react-helmet';

import Subs from 'app/components/Subs';
import Empty from 'app/components/Empty';

import enhanceSubsPage from './enhanceSubsPage';


type Props = {
  title: string,
  header: string,
  students: Object,
};

const SubsPage = ({ title, header, students }: Props) => (
  <div>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <h1>{header}</h1>
    {students.keys.length === 0
      ? <Empty />
      : <Subs />
    }
  </div>
);

export default enhanceSubsPage(SubsPage);
